export default "__VITE_ASSET__Ru$ywL4glQBqWhWoJo7rJg__"